<h2 class="page-title">No Hits</h2>

<div class="card-section">
  <div class="panel-row">
    <div class="dh-panel tint-dh1">
      <b>No Hits 1</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.no_hits[0].url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.no_hits[0].page_source"></textarea>
      </div>
    </div>

    <div class="dh-panel tint-dh2">
      <b>No Hits 2</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.no_hits[1].url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.no_hits[1].page_source"></textarea>
      </div>
    </div>
  </div>
</div>
